(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["AGT-banner-below-icons"] && !Shopify.designMode) return;
  try {
    
  // Additional JavaScript can be added here if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agt-insta-1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // No JavaScript needed for the grid layout
  // The grid is handled by CSS Grid
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agt-insta"] && !Shopify.designMode) return;
  try {
    
// Optional JavaScript for additional functionality
// For example, you could add lazy loading or dynamic feed fetching
document.addEventListener('DOMContentLoaded', function() {
  // Add any additional JavaScript functionality here
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agt-logo-swiper"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    loadSwiper();
  });

  function loadSwiper() {
    if (typeof Swiper === 'undefined') {
      // Add Swiper CSS
      const swiperCSS = document.createElement('link');
      swiperCSS.rel = 'stylesheet';
      swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
      document.head.appendChild(swiperCSS);

      // Add Swiper JS
      const swiperScript = document.createElement('script');
      swiperScript.src = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
      swiperScript.onload = initSwiper;
      document.body.appendChild(swiperScript);
    } else {
      initSwiper();
    }
  }

  function initSwiper() {
    const logoCarousel = new Swiper('.logo-carousel-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 30,
      loop: true,
      grabCursor: true,
      autoplay: {
        // delay: {{ section.settings.autoplay_speed | times: 1000 }},
        delay: 0,
        disableOnInteraction: false,
      },
      speed: 3000,
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        480: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-slideshow-v1"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initArrows(sectionEl) {
    var sectionId = sectionEl.getAttribute('data-section-id');
    var slickEl   = sectionEl.querySelector('.slick-side-h1');
    var prevBtn   = sectionEl.querySelector('.slideshow-arrow-prev-' + sectionId);
    var nextBtn   = sectionEl.querySelector('.slideshow-arrow-next-' + sectionId);

    if (!slickEl || (!prevBtn && !nextBtn)) return;

    function goTo(dir) {
      if (typeof jQuery !== 'undefined' && jQuery(slickEl).hasClass('slick-initialized')) {
        jQuery(slickEl).slick(dir === 'prev' ? 'slickPrev' : 'slickNext');
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo('prev'); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo('next'); });
  }

  /* Init on DOM ready */
  document.addEventListener('DOMContentLoaded', function () {
    document
      .querySelectorAll('[data-section-type="section-slideshow-v1"]')
      .forEach(function (el) { initArrows(el); });
  });

  /* Re-init on Shopify section:load (Theme Editor) */
  document.addEventListener('shopify:section:load', function (e) {
    var sectionEl = e.target.querySelector('[data-section-type="section-slideshow-v1"]');
    if (sectionEl) initArrows(sectionEl);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
